export default {
  email: {
    presence: { allowEmpty: false, message: "is required" },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      minimum: 8,
      maximum: 99
    },
    format: {
      //eslint-disable-next-line
      pattern: /^(?=.*\d)(?=.*[\^$*.\[\]\{\}\(\)\?\-"!@#%&\/\,><':;|_~`])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      message: "should contain at least one number, special characters, uppercase letter and lowercase letter"
    }
  },
  confirmPassword: {
    presence: { allowEmpty: false, message: "is required" },
    length: {
      minimum: 8,
      maximum: 99
    },
    equality: {
      attribute: "password",
      message: "Passwords do not match",
      comparator: (v1, v2) => {
        return v1 === v2;
      }
    },
    format: {
      //eslint-disable-next-line
      pattern: /^(?=.*\d)(?=.*[\^$*.\[\]\{\}\(\)\?\-"!@#%&\/\,><':;|_~`])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
      message: "should contain at least one number, special characters, uppercase letter and lowercase letter"
    }
  },
  policy: {
    presence: { allowEmpty: false, message: "is required" },
    checked: true
  }
};
